import { useEffect } from "react";
import { visitApi } from "../services/api";

const { addVisitLog } = visitApi;

export const TrackVisit = () => {
  useEffect(() => {
    // 获取或生成会话 ID
    let sessionId = sessionStorage.getItem("session_id");
    const isNewSession = !sessionId;

    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem("session_id", sessionId);
      sessionStorage.setItem("session_start", Date.now());
    }

    // 只在首次进入页面时统计访问
    if (isNewSession) {
      const trackData = {
        visitorId: localStorage.getItem("user_id") || generateUUID(),
      };

      addVisitLog({ ...trackData }).catch(console.error);

      // 标记长期用户 ID
      if (!localStorage.getItem("user_id")) {
        localStorage.setItem("user_id", trackData.visitorId);
      }
    }

    // 页面关闭时清理 sessionStorage
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("session_id");
      sessionStorage.removeItem("session_start");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return null;
};

// 兼容全浏览器的 UUID 生成方案
const generateUUID = () => {
  // 优先使用标准的 crypto.randomUUID
  if (typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  // 兼容旧版浏览器（IE11+）
  try {
    const buffer = new Uint8Array(16);
    window.crypto.getRandomValues(buffer);

    // 设置 UUID 版本号 (v4)
    buffer[6] = (buffer[6] & 0x0f) | 0x40;
    buffer[8] = (buffer[8] & 0x3f) | 0x80;

    return Array.from(buffer)
      .map((b, i) => {
        return (
          b.toString(16).padStart(2, "0") +
          ([4, 6, 8, 10].includes(i) ? "-" : "")
        );
      })
      .join("");
  } catch (e) {
    // 终极回退方案：时间戳 + 随机数
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
};
